import Vue from 'vue'
import Router from 'vue-router'
import  home from '../views/home.vue'
import  game from '../views/game.vue'
import  serve from '../views/serve.vue'
import  newslist from '../views/news-list.vue'
import  news from '../views/news.vue'
import  common from '../views/common.vue'
import  tracking from '../views/tracking.vue'
import  tracklist from '../views/tracklist.vue'
import  clogin from '../views/chooselogin.vue'
import  sun1 from '../components/sun1.vue'
import  sun2 from '../components/sun2.vue'
import  sun3 from '../components/sun3.vue'
import  sun8 from '../components/sun8.vue'
import  sun15 from '../components/sun15.vue'
import  sun18 from '../components/sun18.vue'
import  sun22 from '../components/sun22.vue'
import  ro1 from '../components/ro1.vue'
import  ro2 from '../components/ro2.vue'
import  ro3 from '../components/ro3.vue'
import  ro4 from '../components/ro4.vue'
import  ro5 from '../components/ro5.vue'
import  ro6 from '../components/ro6.vue'
import  ro7 from '../components/ro7.vue'
import  ro8 from '../components/ro8.vue'
import  ro9 from '../components/ro9.vue'
//import  ro10 from '../components/ro10.vue'
import  ro11 from '../components/ro11.vue'
import  vip from '../components/vip.vue'
import  vip1 from '../components/vip1.vue'
import  vip2 from '../components/vip2.vue'
import  complain from '../components/complain.vue'
import  complain1 from '../components/complain1.vue'
import  errview from '../views/404.vue'
import  sun_vip from '../views/sun_vip.vue'
import  mu_vip from '../views/mu_vip.vue'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      component:errview
    },
	{
	    path: '/',
	    component:clogin
	},
    {
        path: '/home',
        component:home
    },
    {
        path: '/game',
        component: game,
    }
    ,
    {
        path: '/serve',
        component: serve
    }
    ,
	{
        path: '/newslist',
        component: newslist
    }
    ,
    {
        path: '/common',
        component:common,
		children:[
			{
			    path: 'sun1',
			    component: sun1
			},
			{
			    path: 'sun2',
			    component: sun2
			},
			{
			    path: 'sun3',
			    component: sun3
			},
			{
			    path: 'sun8',
			    component: sun8
			},
			{
			    path: 'sun15',
			    component: sun15
			},
			{
			    path: 'sun18',
			    component: sun18
			},
			{
			    path: 'sun22',
			    component: sun22
			},
			{
			    path: 'vip',
			    component: vip
			},
			{
			    path: 'vip1',
			    component: vip1
			},
			{
			    path: 'vip2',
			    component: vip2
			},
			{
			    path: 'ro1',
			    component: ro1
			},
			{
			    path: 'ro2',
			    component: ro2
			},
			{
			    path: 'ro3',
			    component: ro3
			},
			{
			    path: 'ro4',
			    component: ro4
			},
			{
			    path: 'ro5',
			    component: ro5
			},
			{
			    path: 'ro6',
			    component: ro6
			},
			{
			    path: 'ro7',
			    component: ro7
			},
			{
			    path: 'ro8',
			    component: ro8
			},
			{
			    path: 'ro9',
			    component: ro9
			},
			// {
			//     path: 'ro10',
			//     component: ro10
			// },
			{
			    path: 'ro11',
			    component: ro11
			},
		]
    },
	{
	    path: '/tracking',
	    component:tracking
	},
	{
	    path: '/complain',
	    component:complain
	},
	{
	    path: '/complain1',
	    component:complain1
	},
	{
	    path: '/tracklist',
	    component:tracklist
	},
	{
	    path: '/news',
	    component:news
	},
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js